import { Button, Typography } from "@mui/material";


type SeletorQuantidadeDoItemOuSaborProps = {
  selectedQuantity: number,
  handleAdd: () => void,
  handleSubtract: () => void,
  addDisabled: boolean,
  subtractDisabled: boolean,
}

export default function SeletorQuantidadeDoItemOuSabor(props: SeletorQuantidadeDoItemOuSaborProps){

  const {
    selectedQuantity,
    handleAdd,
    handleSubtract,
    addDisabled,
    subtractDisabled,
} = props;

  return(
    <>
      <Button
        variant="outlined"
        sx={{
          fontSize: "15px",
          minWidth: "25px",
          maxHeight: "25px",
          width: "25px",
        }}
        onClick={handleSubtract}
        disabled={subtractDisabled}
      >
        -
      </Button>
      <Typography
        style={{
          margin: "0 4px",
          fontWeight: 700,
        }}
      >
        {selectedQuantity}
      </Typography>
      <Button
        variant="outlined"
        sx={{
          fontSize: "15px",
          minWidth: "25px",
          maxHeight: "25px",
          width: "25px",
        }}
        onClick={() => handleAdd()}
        disabled={addDisabled}
      >
        +
      </Button>
    </>

  )
}